export const isAuthenticated = () => {
    // Logica que pega o token no storage 
    const token = localStorage.getItem('provider_token');
    return token ? true : false;
};